'use client'
import {
  useConfig_default
} from "./chunk-UGF34K5Q.mjs";

// src/hooks/useTranslation.ts
var useTranslation = (...args) => {
  return useConfig_default().i18n.useTranslation(...args);
};

export {
  useTranslation
};
//# sourceMappingURL=chunk-7GMAVXAZ.mjs.map